import React, { useEffect, useState } from "react";
import withRouter from "../../withRouter";
import Menu from "../../Component/Menu";
import Header from "../../Component/Header";
import Footer from "../../Component/Footer";
import { spin } from "../../Common/NewLoader";
import { Link } from "react-router-dom";
import { FormControlLabel, ThemeProvider, createTheme } from "@mui/material";
import MUIDataTable from "mui-datatables";
import CustomToolbar from "../../CommonComponents/CustomToolbar";
import ProjectManagementServices from "../ProjectManagementServices";
import { currentTenant } from "../../Common/Credentials";
import Swal from "sweetalert2";
import IOSSwitch from "../../CommonComponents/IOSSwitch";

const theme = createTheme({
  overrides: {
    MuiTableCell: {
      head: {
        backgroundColor: "#e9ecef !important",
        border: [[1, "solid", "#ece6e6"]],
      },
      body: {
        border: [[1, "solid", "#ece6e6"]],
      },
    },
  },
});

const ProjectEstimation = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [status, setStatus] = useState("Pending"); // Default status

  // Fetch data based on status
  const fetchEstimationData = (status) => {
    setLoading(true);
    let apiCall;

    // Make API calls based on selected status
    switch (status) {
      case "Pending":
        apiCall = ProjectManagementServices.GetActiveEstimations(currentTenant);
        break;
      case "Completed":
        apiCall = ProjectManagementServices.GetCompletedEstimations(currentTenant);
        break;
      case "Cancelled":
        apiCall = ProjectManagementServices.GetCancelledEstimations(currentTenant);
        break;
      default:
        apiCall = ProjectManagementServices.GetActiveEstimations(currentTenant); // Default to pending
    }

    // Fetch and set data
    apiCall
      .then((response) => {
        setData(response.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  const handleStatusChange = (newStatus) => {
    setStatus(newStatus);
    fetchEstimationData(newStatus);  // Fetch data for the new status
  };

  useEffect(() => {
    fetchEstimationData("Pending");  // Initial load with pending estimations
  }, []);

  const handleDelete = (id) => {
    Swal.fire({
      title: `Are you sure you want to delete?`,
      text: ".",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      confirmButtonColor: "#152f5f",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        ProjectManagementServices.DeleteByEstimatedId(id).then(() =>
          fetchEstimationData(status)  // Reload data after deletion
        );
      }
    });
  };

  const columns = [
    { name: "estimationId", label: "Estimation Id", options: { filter: true, sort: true } },
    { name: "projectName", label: "Project", options: { filter: true, sort: true } },
    { name: "customerName", label: "Customer", options: { filter: true, sort: true } },
    { name: "projectManagerName", label: "Project Manager", options: { filter: true, sort: true } },
    { name: "preparedBy", label: "Prepared By", options: { filter: true, sort: true } },
    {
      name: "Actions",
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Link
                as="button"
                data-tip
                data-for="edit"
                className="fa fa-list-alt cursorPointer mx-2"
                to={{ pathname: `/projectestimation/${tableMeta.rowData.find((e) => e)}` }}
              ></Link>
              {/* <span
                as="button"
                className="fa fa-trash text-danger cursorPointer"
                onClick={() => handleDelete(tableMeta.rowData.find((e) => e))}
              ></span> */}
            </>
          );
        },
      },
    },
  ];

  const options = {
    filterType: "checkbox",
    selectableRows: "none",
    customToolbar: () => {
      return (
        <Link
          as="button"
          className="float-right btn btn-sm m-0 p-0"
          to={{ pathname: "/newprojectestimation" }}
          state={{ id: -1, pagename: "New Project Estimation" }}
        >
          <CustomToolbar />
        </Link>
      );
    },
    onDownload: (buildHead, buildBody, columns, data) => {
      return "\uFEFF" + buildHead(columns) + buildBody(data);
    },
    downloadOptions: {
      filename: "Projects",
      separator: ",",
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      },
    },
  };

  return (
    <div>
      <Header />
      <Menu />
      <div className="content-wrapper">
        <div className="card card-info">
          <ol className="breadcrumb float-sm-right">
            <li className="breadcrumb-item text-secondary">
              <Link to="/projectmanagement">Home</Link>
            </li>
            <li className="breadcrumb-item active">Project Estimation</li>
          </ol>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    {/* <div className="card-header">
                      <h3 className="card-title"> Project Estimations </h3>
                    </div> */}
                    <div className="card-body">
                      <div className="form-row">
                        <fieldset className="form-group col-md-4">
                          <span className="mx-3">Pending</span>
                          <FormControlLabel
                            control={
                              <IOSSwitch
                                checked={status === "Pending"}
                                onChange={() => handleStatusChange("Pending")}
                              />
                            }
                          />
                        </fieldset>
                        <fieldset className="form-group col-md-4">
                          <span className="mx-3">Completed</span>
                          <FormControlLabel
                            control={
                              <IOSSwitch
                                checked={status === "Completed"}
                                onChange={() => handleStatusChange("Completed")}
                              />
                            }
                          />
                        </fieldset>
                        <fieldset className="form-group col-md-4">
                          <span className="mx-3">Cancelled</span>
                          <FormControlLabel
                            control={
                              <IOSSwitch
                                checked={status === "Cancelled"}
                                onChange={() => handleStatusChange("Cancelled")}
                              />
                            }
                          />
                        </fieldset>

                        {loading === true ? (
                          <div className="text-center">{spin}</div>
                        ) : (
                          <div className="form-group col-md-12">
                            <ThemeProvider theme={theme}>
                              <MUIDataTable
                                className="table-sm"
                                title={"Project Estimation"}
                                data={data}
                                columns={columns}
                                options={options}
                              />
                            </ThemeProvider>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default withRouter(ProjectEstimation);
